import type * as SchemaTypes from '../types';

import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import { gql } from '@apollo/client';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
export type EdmSocialMediaDataFragment = (
  { __typename: 'EdmEmailSocialMedia' }
  & Pick<SchemaTypes.EdmEmailSocialMedia, 'id' | 'altText' | 'url'>
  & { icon?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )> }
);

export const EdmSocialMediaDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EdmSocialMediaData on EdmEmailSocialMedia {
  id
  altText
  url
  icon {
    ...UploadFileWithPreviewFormData
  }
}
    `;